import dayjs from 'dayjs';
import { internalDateFormat } from '../constants';
export const convertDateToInternalFormat = (dates) => {
    const date = dates === null || dates === void 0 ? void 0 : dates[0];
    if (!date) {
        return '';
    }
    return dayjs(date).format(internalDateFormat.dayjs);
};
//# sourceMappingURL=convertDateToInternalFormat.js.map